import { useEffect, useState } from 'react';

/**
 * `true` khi cửa sổ hẹp hơn `nguong` px — điện thoại, hoặc máy bàn thu nhỏ.
 *
 * Có từ 14/09 cho màn thu ngân: bố cục hai tấm cạnh nhau (hàng đợi 396px + chi
 * tiết) không nhét vào 390px được. Dưới ngưỡng thì thành HAI MÀN nối tiếp: danh
 * sách → bấm một đơn → chi tiết có nút quay lại. Cùng dữ liệu, cùng thành phần,
 * chỉ khác cách xếp — không dựng một màn thu ngân thứ hai rồi để nó lệch dần.
 *
 * Ngưỡng 760: hai tấm cần tối thiểu ~396 + 14 + 340 để cột phải còn đọc được
 * tên hàng + số tiền trên một dòng. iPad dọc (768) vẫn hai tấm — đo thấy vừa.
 *
 * Dùng `matchMedia` chứ không đo `innerWidth` mỗi lần vẽ: trình duyệt tự báo
 * khi qua ngưỡng, không phải lắng nghe resize liên tục.
 */
export function useHep(nguong = 760): boolean {
  const truyVan = `(max-width: ${nguong}px)`;
  const [hep, datHep] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(truyVan).matches
      : false,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(truyVan);
    const f = (e: MediaQueryListEvent) => datHep(e.matches);
    datHep(mq.matches);
    mq.addEventListener('change', f);
    return () => mq.removeEventListener('change', f);
  }, [truyVan]);
  return hep;
}
